export const FIELD_SET_VALUE = 'FIELD_SET_VALUE'
export const FIELD_VALIDATE = 'FIELD_VALIDATE'
export const FIELD_SET_FILE = 'FIELD_SET_FILE'
export const SET_FORM_INITIAL_STATE = 'SET_FORM_INITIAL_STATE'

export const initialState = {
  userProfile: {
    avatar: {
      image: '',
      file: false,
    },
    defaultBuildingId: {
      value: '',
      isValid: false,
    },
    firstName: {
      value: '',
      isValid: false,
    },
    lastName: {
      value: '',
      isValid: false,
    },
    email: {
      value: '',
      isValid: false,
    },
    code: {
      value: '',
      isValid: false,
    },
    birth: {
      value: '',
      isValid: false,
    },
    gender: {
      value: '',
      isValid: false,
    },
    phone: {
      value: '',
      isValid: false,
    },
    notification: {
      value: false,
      isValid: false,
    },
    newsletter: {
      value: false,
      isValid: false,
    },
    street: {
      value: '',
      isValid: false,
    },
    apartment: {
      value: '',
      isValid: false,
    },
    zipCode: {
      value: '',
      isValid: false,
    },
  },
  clientProfile: {
    avatar: {
      image: '',
      file: false,
    },
    active: {
      value: false,
      isValid: false,
    },
    firstName: {
      value: '',
      isValid: false,
    },
    lastName: {
      value: '',
      isValid: false,
    },
    email: {
      value: '',
      isValid: false,
    },
    birth: {
      value: '',
      isValid: false,
    },
    gender: {
      value: '',
      isValid: false,
    },
    phone: {
      value: '',
      isValid: false,
    },
    street: {
      value: '',
      isValid: false,
    },
    apartment: {
      value: '',
      isValid: false,
    },
    zipCode: {
      value: '',
      isValid: false,
    },
    code: {
      value: '',
      isValid: false,
    },
  },
  clientProspectProfile: {
    avatar: {
      image: '',
      file: false,
    },
    firstName: {
      value: '',
      isValid: false,
    },
    lastName: {
      value: '',
      isValid: false,
    },
    email: {
      value: '',
      isValid: false,
    },
    gender: {
      value: '',
      isValid: false,
    },
    phone: {
      value: '',
      isValid: false,
    },
    street: {
      value: '',
      isValid: false,
    },
    apartment: {
      value: '',
      isValid: false,
    },
    zipCode: {
      value: '',
      isValid: false,
    },
    code: {
      value: '',
      isValid: false,
    },
  },
  clientProspectProfileTasks: {},
  building: {
    logo: {
      image: '',
      file: false,
    },
    image: {
      image: '',
      file: false,
    },
    name: {
      value: '',
      isValid: false,
    },
    address: {
      value: '',
      isValid: false,
    },
    postalCode: {
      value: '',
      isValid: false,
    },
    phone: {
      value: '',
      isValid: false,
    },
    code: {
      value: '',
      isValid: false,
    },
    link: {
      value: '',
      isValid: false,
    },
  },
  createEventFile: {
    PDF: {
      image: '',
      file: false,
    },
  },
}

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIELD_SET_VALUE:
      return {
        ...state,
        [action.formType]: {
          ...state[action.formType],
          [action.fieldName]: {
            ...state[action.formType][action.fieldName],
            value: action.value,
          },
        },
      }
    case FIELD_SET_FILE:
      return {
        ...state,
        [action.formType]: {
          ...state[action.formType],
          [action.fieldName]: {
            ...state[action.formType][action.fieldName],
            image: action.image,
            file: action.file,
          },
        },
      }
    case FIELD_VALIDATE:
      return {
        ...state,
        [action.formType]: {
          ...state[action.formType],
          [action.fieldName]: {
            ...state[action.formType][action.fieldName],
            isValid: action.isValid,
          },
        },
      }
    case SET_FORM_INITIAL_STATE:
      return {
        ...state,
        [action.formType]: initialState[action.formType],
      }
    default:
      return state
  }
}

export default formReducer

export const setFormFieldValue = (formType, fieldName, value) => {
  return {
    type: FIELD_SET_VALUE,
    formType,
    fieldName,
    value,
  }
}

export const validateFormField = (formType, fieldName, isValid) => {
  return {
    type: FIELD_VALIDATE,
    formType,
    fieldName,
    isValid,
  }
}

export const setFormFieldFile = (formType, fieldName, image, file) => {
  return {
    type: FIELD_SET_FILE,
    formType,
    fieldName,
    image,
    file,
  }
}

export const setFormInitialState = (formType) => {
  return {
    type: SET_FORM_INITIAL_STATE,
    formType,
  }
}
